import { Route } from 'react-router-dom'
import ViewNotice from 'screens/Noticeboard/components/ViewNotice'
import Noticeboard from 'screens/Noticeboard/Noticeboard'

const INDEX = 'noticeboard'
const VIEW = ':id'

export const noticeboardRoutes = (
  <Route path={INDEX}>
    <Route element={<Noticeboard />} index />
    <Route path={VIEW} element={<ViewNotice />} />
  </Route>
)

export default noticeboardRoutes
